/** Convite de parceria de uma construtora (hub#753). Decide o vínculo, não um lançamento. */
export interface LaunchPartnershipInvite {
  id: string;
  developerName: string;
  status: "pending" | "accepted" | "declined" | "revoked";
  invitedAt: string;
}

/** Lançamento que a imobiliária recebeu. */
export interface ReceivedLaunch {
  inviteId: string;
  launchId: string;
  launchName: string;
  developerName: string;
  city: string;
  state: string;
  status: "pending" | "accepted" | "declined" | "revoked";
  invitedAt: string;
  /** Quantos do quadro já receberam por repasse — se 0, parou aqui. */
  relayedTo: number;
}

export interface RelayResult {
  relayed: number;
  skipped: number;
  unresolved: string[];
}

const invites: LaunchPartnershipInvite[] = [
  { id: "inv-1", developerName: "Construtora Aurora", status: "pending", invitedAt: "2026-08-05T12:00:00Z" },
  { id: "inv-2", developerName: "Incorporadora Sul", status: "accepted", invitedAt: "2026-07-28T12:00:00Z" },
];

const launches: ReceivedLaunch[] = [
  {
    inviteId: "lnv-1",
    launchId: "lch-1",
    launchName: "Reserva das Águas",
    developerName: "Incorporadora Sul",
    city: "Florianópolis",
    state: "SC",
    status: "accepted",
    invitedAt: "2026-08-01T12:00:00Z",
    relayedTo: 3,
  },
  {
    inviteId: "lnv-2",
    launchId: "lch-2",
    launchName: "Skyline Corporate",
    developerName: "Construtora Aurora",
    city: "São Paulo",
    state: "SP",
    status: "pending",
    invitedAt: "2026-08-06T12:00:00Z",
    relayedTo: 0,
  },
];

export const listInvites = async (): Promise<LaunchPartnershipInvite[]> => invites;
export const listLaunches = async (): Promise<ReceivedLaunch[]> => launches;
export const respondInvite = async (): Promise<void> => {};
export const relayLaunch = async (codes: string[]): Promise<RelayResult> => ({
  relayed: codes.length,
  skipped: 0,
  unresolved: [],
});
